import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectGroupByClass {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectGroupByClass = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectGroupByClass) => {
  const itemList = useStoreState((state) => state.exam.groupDropdownlist);

  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.groupId === id);
      onChange(value.groupId);
    }
  };





  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      className="classSelectByGroup"
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Group"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.groupId} value={type.groupId}>
            {type.groupName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Group</Option>
      )}
    </Select>
  );
};
